import { useState, useEffect } from 'react';
import dayjs from 'dayjs';

import * as URLS from '../constants/urls';
import * as api from '../utils/api';
import { getQueryParam } from '../utils/helpers';
import { tradingPeriod } from '../pages/Dashboard/Dashboard.helpers';
import useHeader from './useHeader';

export const tabMenu = [
  {
    value: '0',
    label: 'Toàn thị trường',
  },
  {
    value: '1',
    label: 'HOSE',
  },
  {
    value: '2',
    label: 'HNX',
  },
  {
    value: '3',
    label: 'UPCOM',
  },
];

const DAY = 180;

const useDashboard = () => {
  const { accountInformationData: userInfo } = useHeader();
  const url = `${document.location.origin}${document.location.pathname}`;
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedStock, setStock] = useState(null);
  const [isAppLoading, setAppLoading] = useState(true);
  const [isTop10TradingValueLoading, setTop10TradingValueLoading] = useState(
    true
  );
  const [top10TradingValueData, setTop10TradingValueData] = useState([]);
  const [isTop10TradingVolumeLoading, setTop10TradingVolumeLoading] = useState(
    true
  );
  const [top10TradingVolumeData, setTop10TradingVolumeData] = useState([]);
  const [isTop10IncreaseLoading, setTop10IncreaseLoading] = useState(true);
  const [topTop10IncreaseData, setTop10IncreaseData] = useState([]);
  const [isTop10LowestLoading, setTop10LowestLoading] = useState(true);
  const [topTop10LowestData, setTop10LowestData] = useState([]);
  const [isTop10ChartDataLoading, setTop10ChartDataLoading] = useState(false);

  const [selectedPeriod, setSelectedPeriod] = useState({
    value: tradingPeriod[0].value,
    volume: tradingPeriod[0].value,
  });
  const [isTradingVolumeChartLoading, setTradingVolumeChartLoading] = useState(
    false
  );
  const [isTradingValueChartLoading, setTradingValueChartLoading] = useState(
    false
  );
  const [tradingValueChartData, setTradingValueChartData] = useState(null);
  const [tradingVolumeChartData, setTradingVolumeChartData] = useState(null);

  const [
    isTradingVolumeHistoryLoading,
    setTradingVolumeHistoryLoading,
  ] = useState(true);
  const [tradingVolumeHistory, setTradingVolumeHistory] = useState(null);
  const [
    isTradingValueHistoryLoading,
    setTradingValueHistoryLoading,
  ] = useState(true);
  const [tradingValueHistory, setTradingValueHistory] = useState(null);
  const [
    isTradingValueBySectorLoading,
    setTradingValueBySectorLoading,
  ] = useState(true);
  const [topTradingValueBySectorData, setTradingValueBySectorData] = useState(
    []
  );
  const [
    isTradingVolumeBySectorLoading,
    setTradingVolumeBySectorLoading,
  ] = useState(true);
  const [topTradingVolumeBySectorData, setTradingVolumeBySectorData] = useState(
    []
  );
  const [isTop5TransferValueLoading, setTop5TransferValueLoading] = useState(
    true
  );
  const [topTop5TransferValueData, setTop5TransferValueData] = useState([]);
  const [isTop5TradingVolumeLoading, setTop5TradingVolumeLoading] = useState(
    false
  );
  const [topTop5TradingVolumeData, setTop5TradingVolumeData] = useState([]);
  const [
    isTradingVolumeLargeCapLoading,
    setTradingVolumeLargeCapLoading,
  ] = useState(true);
  const [tradingVolumeLargeCapData, setTradingVolumeLargeCapData] = useState(
    null
  );
  const [
    isTradingVolumeMidCapLoading,
    setTradingVolumeMidCapLoading,
  ] = useState(true);
  const [tradingVolumeMidCapData, setTradingVolumeMidCapData] = useState(null);
  const [
    isTradingVolumeSmallCapLoading,
    setTradingVolumeSmallCapLoading,
  ] = useState(true);
  const [tradingVolumeSmallCapData, setTradingVolumeSmallCapData] = useState(
    null
  );
  const [
    isTradingVolumeMicroCapLoading,
    setTradingVolumeMicroCapLoading,
  ] = useState(true);
  const [tradingVolumeMicroCapData, setTradingVolumeMicroCapData] = useState(
    null
  );
  const [
    isTradingValueLargeCapLoading,
    setTradingValueLargeCapLoading,
  ] = useState(true);
  const [tradingValueLargeCapData, setTradingValueLargeCapData] = useState(
    null
  );
  const [isTradingValueMidCapLoading, setTradingValueMidCapLoading] = useState(
    true
  );
  const [tradingValueMidCapData, setTradingValueMidCapData] = useState(null);
  const [
    isTradingValueSmallCapLoading,
    setTradingValueSmallCapLoading,
  ] = useState(true);
  const [tradingValueSmallCapData, setTradingValueSmallCapData] = useState(
    null
  );
  const [
    isTradingValueMicroCapLoading,
    setTradingValueMicroCapLoading,
  ] = useState(true);
  const [tradingValueMicroCapData, setTradingValueMicroCapData] = useState(
    null
  );
  const [tradingVolumeChartType, setTradingVolumeChartType] = useState(
    'percent'
  );
  const [tradingValueChartType, setTradingValueChartType] = useState('percent');

  const [top5ChartData, setTop5ChartData] = useState({
    klgd: null,
    gtgd: null,
  });

  const [top8ChartData, setTop8ChartData] = useState({
    klgd: null,
    gtgd: null,
  });

  const [top10GoUpGoDownChartData, setTop10GoUpGoDownChartData] = useState({
    goUp: null,
    goDown: null,
  });

  const [top10ChartData, setTop10ChartData] = useState({
    goUpPercent: null,
    goDownPercent: null,
    klgd: null,
    gtgd: null,
  });

  const [isTop10GoUpLoading, setTop10GoUpLoading] = useState(true);
  const [top10GoUpData, setTop10GoUpData] = useState([]);

  const [isTop10GoDownLoading, setTop10GoDownLoading] = useState(true);
  const [top10GoDownData, setTop10GoDownData] = useState([]);

  const [selectedChartPeriod, setSelectedChartPeriod] = useState(
    tradingPeriod[0].value
  );
  const [isChartDataByCodeLoading, setChartDataByCodeLoading] = useState(false);
  const [chartDataByCode, setChartDataByCode] = useState(null);
  const [isChartModalShow, setChartModalShow] = useState(false);
  const [selectedDataChartModal, setSelectedDataChartModal] = useState({
    code: '',
    field: '',
  });

  const LIMIT = 50;
  const [isNewsLoading, setNewsLoading] = useState(true);
  const [totalPage, setTotalPage] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [news, setNews] = useState([]);
  const [isNewsSourceLoading, setNewsSourceLoading] = useState(false);
  const [newsSource, setNewsSource] = useState([]);
  const [selectedNewsSource, setSelectedNewsSource] = useState(null);
  const [offsets, setOffsets] = useState(null);
  const [newsConfig, setNewsConfig] = useState(null);
  const [marketNews, setMarketNews] = useState(null);
  const [isMarketNewsLoading, setMarketNewsLoading] = useState(false);
  const [upTrendingData, setUpTrendingData] = useState([]);
  const [isUpTrendingDataLoading, setUpTrendingDataLoading] = useState(false);
  const [sectorTrendingDate, setSectorTrendingDate] = useState({
    startDate: dayjs().startOf('month'),
    endDate: dayjs().endOf('month'),
  });

  const [
    tradingVolumeExchangeHistoryChartData,
    setTradingVolumeExchangeHistoryChartData,
  ] = useState(null);

  const [
    tradingValueExchangeHistoryChartData,
    setTradingValueExchangeHistoryChartData,
  ] = useState(null);

  const fetchUpTrending = async (startDate, endDate) => {
    setUpTrendingDataLoading(true);
    try {
      const { data } = await api.get(
        `${URLS.GET_TOP_60_SECTOR_UP_TRENDING_DATA}?startDate=${startDate}&endDate=${endDate}&limit=26`
      );
      setUpTrendingData(data.items);
    } catch (error) {
      console.error(error);
    }
    setUpTrendingDataLoading(false);
  };

  const fetchMarketNews = async () => {
    setMarketNewsLoading(true);
    try {
      const { data } = await api.get(URLS.GET_LATEST_MARKET_NEWS_DATA);
      setMarketNews(data);
    } catch (error) {
      console.error(error);
    }
    setMarketNewsLoading(false);
  };

  const fetchNewsSource = async () => {
    if (!selectedDate || !userInfo?.userId) {
      return;
    }
    setNewsSourceLoading(true);
    try {
      const now = dayjs();
      const targetDate = dayjs(selectedDate);
      const diff = now.diff(targetDate, 'd');
      const { data } = await api.get(
        `${URLS.GET_SOURCE_OF_NEWS}?date=${dayjs(selectedDate).format(
          'YYYYMMDD'
        )}&diff=${diff}`
      );
      const totalNews = data.source.reduce(
        (total, current) => total + current.total,
        0
      );
      const options = [
        {
          value: '-1',
          label: 'Tất cả',
          total: totalNews,
        },
      ];
      let newsOffsets = {};
      for (let i = 0; i < data.source.length; i++) {
        options.push({
          value: data.source[i].source,
          label: data.source[i].source,
          total: data.source[i].total,
        });
        newsOffsets = { ...newsOffsets, [data.source[i].source]: 0 };
      }
      setOffsets(newsOffsets);
      setNewsConfig([
        {
          page: 1,
          offsets: {
            ...newsOffsets,
          },
        },
      ]);
      setNewsSource([...options]);
      setTimeout(() => {
        setSelectedNewsSource(options[0]);
      }, 200);
    } catch (error) {
      console.error(error);
    }
    setNewsSourceLoading(false);
  };

  const handleNewsSourceChange = (value) => {
    setCurrentPage(1);
    setSelectedNewsSource(value);
  };

  const fetchNews = async () => {
    if (!userInfo?.userId) {
      return;
    }
    if (selectedDate && newsSource.length) {
      setNewsLoading(true);
      try {
        const now = dayjs();
        const targetDate = dayjs(selectedDate);
        let diff = 0;
        if (
          dayjs(endDate).format('YYYYMMDD') ===
          dayjs(selectedDate).format('YYYYMMDD')
        ) {
          diff = now.diff(targetDate, 'd');
        }
        const sources = [];
        const currentNewsConfig = newsConfig.find(
          (n) => n.page === currentPage
        );
        if (selectedNewsSource?.value === '-1') {
          newsSource.forEach((item) => {
            if (item.value !== '-1' && item.total) {
              sources.push({
                source: item.value,
                offset:
                  currentPage === 1
                    ? 0
                    : currentNewsConfig?.offsets[item.value] || 0,
              });
            }
          });
        } else {
          sources.push({
            source: selectedNewsSource?.value,
            offset:
              currentPage === 1
                ? 0
                : currentNewsConfig?.offsets[selectedNewsSource?.value] || 0,
          });
        }
        const { data } = await api.post(URLS.GET_NEWS_BY_SOURCE_URL, {
          limit: LIMIT,
          date: dayjs(selectedDate).format('YYYYMMDD'),
          diff,
          sources,
          selectedSource: selectedNewsSource?.value || -1,
        });
        let newsBySource = {};
        let newsOffsets = {};
        newsSource?.forEach((item) => {
          const news = data.news.filter((n) => n.source === item.value);
          if (news.length) {
            newsBySource = { ...newsBySource, [item.value]: news };
            newsOffsets = {
              ...newsOffsets,
              [item.value]: offsets[item.value] + news.length,
            };
          }
        });
        if (Object.keys(newsOffsets).length) {
          setOffsets(newsOffsets);
          const item = newsConfig.find((n) => n.page === currentPage + 1);
          if (!item) {
            setNewsConfig([
              ...newsConfig,
              { page: currentPage + 1, offsets: { ...newsOffsets } },
            ]);
          }
        }
        const getNewsList = (news) => {
          const results = [];
          const dates = [];
          news.forEach((item) => {
            const date = dayjs(Number(item.publishedAt)).format('DD/MM/YYYY');
            if (!dates.includes(date)) {
              dates.push(date);
              const sources = [];
              newsSource?.forEach((source) => {
                if (source.value !== '-1' && newsBySource[source.value]) {
                  const news = newsBySource[source.value].filter(
                    (n) =>
                      dayjs(Number(n.publishedAt)).format('DD/MM/YYYY') === date
                  );
                  if (news.length) {
                    sources.push({
                      name: source.label,
                      news,
                    });
                  }
                }
              });
              results.push({
                date,
                sources,
              });
            }
          });
          return results;
        };
        setNews(getNewsList(data.news));
        if (currentPage === 1) {
          setTotalPage(Math.ceil(data.totalItems / LIMIT));
        }
      } catch (error) {
        console.error(error);
      }
      setNewsLoading(false);
    }
  };

  const handlesSelectedChartPeriodChange = (type, value) => {
    setSelectedChartPeriod(value);
  };

  const fetchTradingVolumeChart = async () => {
    setTradingVolumeChartLoading(true);
    try {
      const _startDate =
        Number(selectedPeriod.volume) !== 0
          ? dayjs()
              .subtract(Number(selectedPeriod.volume), 'month')
              .format('YYYYMMDD')
          : '';
      const { data } = await api.get(
        `share/get-trading-volume-chart-of-exchange-history?startDate=${_startDate}&endDate=${dayjs(
          selectedDate
        ).format('YYYYMMDD')}&stockId=${selectedStock}`
      );
      setTradingVolumeChartData(data.items);
    } catch (error) {
      console.error(error);
    }
    setTradingVolumeChartLoading(false);
  };

  const fetchTradingValueChart = async () => {
    setTradingValueChartLoading(true);
    try {
      const _startDate =
        Number(selectedPeriod.value) !== 0
          ? dayjs()
              .subtract(Number(selectedPeriod.value), 'month')
              .format('YYYYMMDD')
          : '';
      const { data } = await api.get(
        `share/get-trading-value-chart-of-exchange-history?startDate=${_startDate}&endDate=${dayjs(
          selectedDate
        ).format('YYYYMMDD')}&stockId=${selectedStock}`
      );
      setTradingValueChartData(data.items);
    } catch (error) {
      console.error(error);
    }
    setTradingValueChartLoading(false);
  };

  const fetchTop10GoUpForChart = async (code, field) => {
    try {
      if (!top10GoUpGoDownChartData[field]?.[code]) {
        const { data } = await api.get(
          `share/get-top-10-go-up-go-down-for-chart?date=${dayjs(
            endDate
          ).format(
            'YYYYMMDD'
          )}&stockId=${selectedStock}&day=${DAY}&code=${code}`
        );
        let newTop10GoUpGoDownChartData = top10GoUpGoDownChartData;
        newTop10GoUpGoDownChartData = {
          ...newTop10GoUpGoDownChartData,
          [field]: {
            ...newTop10GoUpGoDownChartData[field],
            [code]: {
              data: data.items,
            },
          },
        };
        setTop10GoUpGoDownChartData(newTop10GoUpGoDownChartData);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleOpenTop10GoUpGoDownTooltip = async (code, field) => {
    await fetchTop10GoUpForChart(code, field);
  };

  const fetchChartDataByCode = async (code, forceFetch = false) => {
    if (!chartDataByCode || !chartDataByCode?.[code] || forceFetch) {
      setChartDataByCodeLoading(true);
      try {
        const { data } = await api.get(
          `${URLS.GET_CHART_DATA_BY_CODE_URL}?endDate=${dayjs(
            selectedDate
          ).format('YYYYMMDD')}&stockId=${selectedStock}&startDate=${
            selectedChartPeriod
              ? dayjs(selectedDate)
                  .subtract(selectedChartPeriod, 'month')
                  .format('YYYYMMDD')
              : 0
          }&code=${code}`
        );
        let newChartDataByCode = chartDataByCode;
        newChartDataByCode = {
          ...newChartDataByCode,
          [code]: {
            data: data.items,
          },
        };
        setChartDataByCode(newChartDataByCode);
      } catch (error) {
        console.error(error);
      }
      setChartDataByCodeLoading(false);
    }
  };

  const handleOpenTop10Tooltip = async (code) => {
    await fetchChartDataByCode(code);
  };

  useEffect(() => {
    if (isChartModalShow) {
      fetchChartDataByCode(selectedDataChartModal.code, true);
    }
  }, [selectedChartPeriod, selectedDataChartModal, isChartModalShow]);

  const fetchTop10GoUp = async () => {
    setTop10GoUpLoading(true);
    try {
      const { data } = await api.get(
        `super-search/get-top-10-go-up?stockId=${selectedStock}&date=${dayjs(
          endDate
        ).format('YYYYMMDD')}`
      );
      setTop10GoUpData(data.items);
    } catch (error) {
      console.error(error);
    }
    setTop10GoUpLoading(false);
  };

  const fetchTop10GoDown = async () => {
    setTop10GoDownLoading(true);
    try {
      const { data } = await api.get(
        `super-search/get-top-10-go-down?stockId=${selectedStock}&date=${dayjs(
          endDate
        ).format('YYYYMMDD')}`
      );
      setTop10GoDownData(data.items);
    } catch (error) {
      console.error(error);
    }
    setTop10GoDownLoading(false);
  };

  const fetchTop10TradingValue = async () => {
    setTop10TradingValueLoading(true);
    try {
      const { data } = await api.get(
        `share/get-top-10-gia-tri-giao-dich-theo-ngay?date=${dayjs(
          selectedDate
        ).format('YYYYMMDD')}&stockId=${selectedStock}`
      );
      setTop10TradingValueData(
        data.sort((a, b) => b.tradingValue > a.tradingValue)
      );
    } catch (error) {
      console.error(error);
    }
    setTop10TradingValueLoading(false);
  };

  const fetchTop10TradingVolume = async () => {
    setTop10TradingVolumeLoading(true);
    try {
      const { data } = await api.get(
        `share/get-top-10-khoi-luong-giao-dich-theo-ngay?date=${dayjs(
          selectedDate
        ).format('YYYYMMDD')}&stockId=${selectedStock}`
      );
      setTop10TradingVolumeData(
        data.sort((a, b) => b.tradingValue > a.tradingValue)
      );
    } catch (error) {
      console.error(error);
    }
    setTop10TradingVolumeLoading(false);
  };

  const fetchTop10Increase = async () => {
    setTop10IncreaseLoading(true);
    try {
      const { data } = await api.get(
        `share/get-top-10-tang-nhieu-nhat-theo-ngay?date=${dayjs(
          selectedDate
        ).format('YYYYMMDD')}&stockId=${selectedStock}`
      );
      setTop10IncreaseData(data);
    } catch (error) {
      console.error(error);
    }
    setTop10IncreaseLoading(false);
  };

  const fetchTop10Lowest = async () => {
    setTop10LowestLoading(true);
    try {
      const { data } = await api.get(
        `share/get-top-10-giam-nhieu-nhat-theo-ngay?date=${dayjs(
          selectedDate
        ).format('YYYYMMDD')}&stockId=${selectedStock}`
      );
      setTop10LowestData(data);
    } catch (error) {
      console.error(error);
    }
    setTop10LowestLoading(false);
  };

  const fetchTradingVolumeHistory = async () => {
    setTradingVolumeHistoryLoading(true);
    try {
      const { data } = await api.get(
        `share/get-trading-volume-of-exchange-history?endDate=${dayjs(
          selectedDate
        ).format('YYYYMMDD')}&stockId=${selectedStock}`
      );
      setTradingVolumeHistory(data);
    } catch (error) {
      console.error(error);
    }
    setTradingVolumeHistoryLoading(false);
  };

  const fetchTradingValueHistory = async () => {
    setTradingValueHistoryLoading(true);
    try {
      const { data } = await api.get(
        `share/get-trading-value-of-exchange-history?endDate=${dayjs(
          selectedDate
        ).format('YYYYMMDD')}&stockId=${selectedStock}`
      );
      setTradingValueHistory(data);
    } catch (error) {
      console.error(error);
    }
    setTradingValueHistoryLoading(false);
  };

  const fetchTradingValueBySectorForTop8 = async (code, field) => {
    try {
      if (!top5ChartData[field]?.[code]) {
        const { data } = await api.post(
          'share/get-trading-value-for-top-8-chart',
          {
            code,
            day: DAY,
            date: dayjs(selectedDate).format('YYYYMMDD'),
            stockId: selectedStock,
          }
        );
        let newTop5ChartData = top5ChartData;
        newTop5ChartData = {
          ...newTop5ChartData,
          [field]: {
            ...newTop5ChartData[field],
            [code]: {
              data,
            },
          },
        };
        setTop8ChartData(newTop5ChartData);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleOpenTradingValueForSectorTooltip = async (code, field) => {
    await fetchTradingValueBySectorForTop8(code, field);
  };

  const fetchTradingValueBySector = async () => {
    setTradingValueBySectorLoading(true);
    try {
      const { data } = await api.get(
        `share/get-gia-tri-giao-dich-theo-ngay?date=${dayjs(
          selectedDate
        ).format('YYYYMMDD')}&day=${DAY}&stockId=${selectedStock}`
      );
      setTradingValueBySectorData(data);
      setTradingValueBySectorLoading(false);
    } catch (error) {
      console.error(error);
      setTradingValueBySectorLoading(false);
    }
  };

  const fetchTradingVolumeBySectorForTop8 = async (code, field) => {
    try {
      if (!top5ChartData[field]?.[code]) {
        const { data } = await api.post(
          'share/get-trading-volume-for-top-8-chart',
          {
            code,
            day: DAY,
            date: dayjs(selectedDate).format('YYYYMMDD'),
            stockId: selectedStock,
          }
        );
        let newTop5ChartData = top5ChartData;
        newTop5ChartData = {
          ...newTop5ChartData,
          [field]: {
            ...newTop5ChartData[field],
            [code]: {
              data,
            },
          },
        };
        setTop8ChartData(newTop5ChartData);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleOpenTradingVolumeBForSectorTooltip = async (code, field) => {
    await fetchTradingVolumeBySectorForTop8(code, field);
  };

  const fetchTradingVolumeBySector = async () => {
    setTradingVolumeBySectorLoading(true);
    try {
      const { data } = await api.get(
        `share/get-khoi-luong-giao-dich-theo-ngay?date=${dayjs(
          selectedDate
        ).format('YYYYMMDD')}&day=${DAY}&stockId=${selectedStock}`
      );
      setTradingVolumeBySectorData(data);
      setTradingVolumeBySectorLoading(false);
    } catch (error) {
      console.error(error);
      setTradingVolumeBySectorLoading(false);
    }
  };

  const fetchTop5TransferValue = async () => {
    setTop5TransferValueLoading(true);
    try {
      const { data } = await api.get(
        `share/get-top-5-transfer-value?date=${dayjs(selectedDate).format(
          'YYYYMMDD'
        )}&stockId=${selectedStock}&day=${DAY}`
      );
      setTop5TransferValueData(data.items);
      setTop5TransferValueLoading(false);
    } catch (error) {
      console.error(error);
      setTop5TransferValueLoading(false);
    }
  };

  const fetchTradingVolumeChartByCode = async (code, field) => {
    try {
      if (!top5ChartData[field]?.[code]) {
        const { data } = await api.get(
          `share/get-trading-volume-chart-by-code?date=${dayjs(
            selectedDate
          ).format(
            'YYYYMMDD'
          )}&stockId=${selectedStock}&day=${DAY}&code=${code}`
        );
        let newTop5ChartData = top5ChartData;
        newTop5ChartData = {
          ...newTop5ChartData,
          [field]: {
            ...newTop5ChartData[field],
            [code]: {
              data,
            },
          },
        };
        setTop5ChartData(newTop5ChartData);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleOpenTradingVolumeTooltip = async (code, field) => {
    await fetchTradingVolumeChartByCode(code, field);
  };

  const fetchTradingValueChartByCode = async (code, field) => {
    try {
      if (!top5ChartData[field]?.[code]) {
        const { data } = await api.get(
          `share/get-trading-value-chart-by-code?date=${dayjs(
            selectedDate
          ).format(
            'YYYYMMDD'
          )}&stockId=${selectedStock}&day=${DAY}&code=${code}`
        );
        let newTop5ChartData = top5ChartData;
        newTop5ChartData = {
          ...newTop5ChartData,
          [field]: {
            ...newTop5ChartData[field],
            [code]: {
              data,
            },
          },
        };
        setTop5ChartData(newTop5ChartData);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleOpenTradingValueTooltip = async (code, field) => {
    await fetchTradingValueChartByCode(code, field);
  };

  const fetchTop5TradingVolume = async () => {
    setTop5TradingVolumeLoading(true);
    try {
      const { data } = await api.get(
        `share/get-top-5-trading-volume?date=${dayjs(selectedDate).format(
          'YYYYMMDD'
        )}&stockId=${selectedStock}`
      );
      setTop5TradingVolumeLoading(false);
      setTop5TradingVolumeData(data.items);
    } catch (error) {
      console.error(error);
      setTop5TradingVolumeLoading(false);
    }
  };

  const fetchTradingVolumeLargeCap = async () => {
    setTradingVolumeLargeCapLoading(true);
    try {
      const { data } = await api.get(
        `history-cap/get-trading-volume-cap?date=${dayjs(selectedDate).format(
          'YYYYMMDD'
        )}&stockId=${selectedStock}&day=${DAY}&type=large`
      );

      const startDate = data.chartData[0].DTYYYYMMDD;
      const endDate = data.chartData[data.chartData.length - 1].DTYYYYMMDD;
      const { data: stockExchange } = await api.get(
        `share/get-trading-volume-chart-of-exchange-history?startDate=${startDate}&endDate=${endDate}&stockId=${selectedStock}`
      );
      setTradingVolumeExchangeHistoryChartData(stockExchange.items);
      setTradingVolumeLargeCapData(data);
    } catch (error) {
      console.error(error);
    }
    setTradingVolumeLargeCapLoading(false);
  };

  const fetchTradingVolumeMidCap = async () => {
    setTradingVolumeMidCapLoading(true);
    try {
      const { data } = await api.get(
        `history-cap/get-trading-volume-cap?date=${dayjs(selectedDate).format(
          'YYYYMMDD'
        )}&stockId=${selectedStock}&day=${DAY}&type=mid`
      );
      setTradingVolumeMidCapData(data);
    } catch (error) {
      console.error(error);
    }
    setTradingVolumeMidCapLoading(false);
  };

  const fetchTradingVolumeSmallCap = async () => {
    setTradingVolumeSmallCapLoading(true);
    try {
      const { data } = await api.get(
        `history-cap/get-trading-volume-cap?date=${dayjs(selectedDate).format(
          'YYYYMMDD'
        )}&stockId=${selectedStock}&day=${DAY}&type=small`
      );
      setTradingVolumeSmallCapData(data);
    } catch (error) {
      console.error(error);
    }
    setTradingVolumeSmallCapLoading(false);
  };

  const fetchTradingVolumeMicroCap = async () => {
    setTradingVolumeMicroCapLoading(true);
    try {
      const { data } = await api.get(
        `history-cap/get-trading-volume-cap?date=${dayjs(selectedDate).format(
          'YYYYMMDD'
        )}&stockId=${selectedStock}&day=${DAY}&type=micro`
      );
      setTradingVolumeMicroCapData(data);
    } catch (error) {
      console.error(error);
    }
    setTradingVolumeMicroCapLoading(false);
  };

  const fetchTradingValueLargeCap = async () => {
    setTradingValueLargeCapLoading(true);
    try {
      const { data } = await api.get(
        `history-cap/get-trading-value-cap?date=${dayjs(selectedDate).format(
          'YYYYMMDD'
        )}&stockId=${selectedStock}&day=${DAY}&type=large`
      );

      const startDate = data.chartData[0].DTYYYYMMDD;
      const endDate = data.chartData[data.chartData.length - 1].DTYYYYMMDD;
      const { data: stockExchange } = await api.get(
        `share/get-trading-value-chart-of-exchange-history?startDate=${startDate}&endDate=${endDate}&stockId=${selectedStock}`
      );
      setTradingValueExchangeHistoryChartData(stockExchange.items);
      setTradingValueLargeCapData(data);
    } catch (error) {
      console.error(error);
    }
    setTradingValueLargeCapLoading(false);
  };

  const fetchTradingValueMidCap = async () => {
    setTradingValueMidCapLoading(true);
    try {
      const { data } = await api.get(
        `history-cap/get-trading-value-cap?date=${dayjs(selectedDate).format(
          'YYYYMMDD'
        )}&stockId=${selectedStock}&day=${DAY}&type=mid`
      );
      setTradingValueMidCapData(data);
    } catch (error) {
      console.error(error);
    }
    setTradingValueMidCapLoading(false);
  };

  const fetchTradingValueSmallCap = async () => {
    setTradingValueSmallCapLoading(true);
    try {
      const { data } = await api.get(
        `history-cap/get-trading-value-cap?date=${dayjs(selectedDate).format(
          'YYYYMMDD'
        )}&stockId=${selectedStock}&day=${DAY}&type=small`
      );
      setTradingValueSmallCapData(data);
    } catch (error) {
      console.error(error);
    }
    setTradingValueSmallCapLoading(false);
  };

  const fetchTradingValueMicroCap = async () => {
    setTradingValueMicroCapLoading(true);
    try {
      const { data } = await api.get(
        `history-cap/get-trading-value-cap?date=${dayjs(selectedDate).format(
          'YYYYMMDD'
        )}&stockId=${selectedStock}&day=${DAY}&type=micro`
      );
      setTradingValueMicroCapData(data);
    } catch (error) {
      console.error(error);
    }
    setTradingValueMicroCapLoading(false);
  };

  const initAppInfo = async () => {
    setAppLoading(true);
    const { data } = await api.get('/share/app-info');
    const lastDate = new Date(data.lastDate);
    setStartDate(new Date(data.startDate));
    setEndDate(lastDate);

    const stock = getQueryParam('stock') || tabMenu[0].value;
    const date = getQueryParam('date');
    setStock(stock);
    if (date) {
      if (dayjs(date).valueOf() <= dayjs(lastDate).valueOf()) {
        setSelectedDate(new Date(date));
      } else {
        setSelectedDate(lastDate);
      }
    } else {
      setSelectedDate(lastDate);
    }
    setAppLoading(false);
  };

  useEffect(() => {
    initAppInfo();
    fetchMarketNews();
    fetchUpTrending(
      sectorTrendingDate.startDate.format('YYYYMMDD'),
      sectorTrendingDate.endDate.format('YYYYMMDD')
    );
  }, []);

  useEffect(() => {
    if (selectedStock !== null || selectedDate !== null) {
      fetchTradingVolumeChart();
    }
  }, [selectedStock, selectedDate, selectedPeriod.volume]);

  useEffect(() => {
    if (selectedStock !== null || selectedDate !== null) {
      fetchTradingValueChart();
    }
  }, [selectedStock, selectedDate, selectedPeriod.value]);

  useEffect(() => {
    if (selectedStock !== null || selectedDate !== null) {
      fetchTradingVolumeHistory();
      fetchTradingValueHistory();
      fetchTop10TradingValue();
      fetchTop10TradingVolume();
      fetchTop10Increase();
      fetchTop10Lowest();
      fetchTop5TransferValue();
      fetchTop5TradingVolume();
      fetchTradingVolumeLargeCap();
      fetchTradingVolumeMidCap();
      fetchTradingVolumeSmallCap();
      fetchTradingVolumeMicroCap();
      fetchTradingValueLargeCap();
      fetchTradingValueMidCap();
      fetchTradingValueSmallCap();
      fetchTradingValueMicroCap();
      fetchTradingValueBySector();
      fetchTradingVolumeBySector();
    }
  }, [selectedStock, selectedDate]);

  useEffect(() => {
    if (selectedStock !== null) {
      fetchTop10GoUp();
      fetchTop10GoDown();
    }
  }, [selectedStock]);

  useEffect(() => {
    fetchNewsSource();
  }, [selectedDate, userInfo]);

  useEffect(() => {
    fetchNews();
  }, [currentPage, selectedDate, selectedNewsSource, newsSource, userInfo]);

  const handleTabChange = (item) => {
    const date = getQueryParam('date') || '';
    history.pushState(null, null, `${url}?stock=${item.value}&date=${date}`);
    setStock(item.value);
  };

  const handleDateChange = (date) => {
    const value = dayjs(date).format('MM/DD/YYYY');
    if (value !== dayjs(selectedDate).format('MM/DD/YYYY')) {
      const stock = getQueryParam('stock') || '0';
      history.pushState(null, null, `${url}?stock=${stock}&date=${value}`);
      setSelectedDate(new Date(date));
    }
  };

  const handlePeriodClick = (type, value) => {
    setSelectedPeriod({
      ...selectedPeriod,
      [type]: value,
    });
  };

  const handleMonthChange = async (startDate, endDate) => {
    setSectorTrendingDate({
      startDate,
      endDate,
    });
    await fetchUpTrending(
      startDate.format('YYYYMMDD'),
      endDate.format('YYYYMMDD')
    );
  };

  return {
    isTop10TradingValueLoading,
    top10TradingValueData,
    isTop10TradingVolumeLoading,
    top10TradingVolumeData,
    isTop10IncreaseLoading,
    topTop10IncreaseData,
    isTop10LowestLoading,
    topTop10LowestData,
    isTradingValueBySectorLoading,
    topTradingValueBySectorData,
    isTradingVolumeBySectorLoading,
    topTradingVolumeBySectorData,
    isTop5TransferValueLoading,
    topTop5TransferValueData,
    isTop5TradingVolumeLoading,
    topTop5TradingVolumeData,
    isTradingVolumeLargeCapLoading,
    tradingVolumeLargeCapData,
    isTradingVolumeMidCapLoading,
    tradingVolumeMidCapData,
    isTradingVolumeSmallCapLoading,
    tradingVolumeSmallCapData,
    isTradingVolumeMicroCapLoading,
    tradingVolumeMicroCapData,
    isTradingValueLargeCapLoading,
    tradingValueLargeCapData,
    isTradingValueMidCapLoading,
    tradingValueMidCapData,
    isTradingValueSmallCapLoading,
    tradingValueSmallCapData,
    isTradingValueMicroCapLoading,
    tradingValueMicroCapData,
    selectedStock,
    selectedDate,
    endDate,
    startDate,
    isAppLoading,
    handleTabChange,
    handleDateChange,
    tradingVolumeChartType,
    setTradingVolumeChartType,
    tradingValueChartType,
    setTradingValueChartType,
    tradingVolumeHistory,
    isTradingVolumeHistoryLoading,
    tradingValueHistory,
    isTradingValueHistoryLoading,
    handleOpenTradingVolumeTooltip,
    handleOpenTradingValueTooltip,
    top5ChartData,
    top8ChartData,
    handleOpenTradingValueForSectorTooltip,
    handleOpenTradingVolumeBForSectorTooltip,
    isTop10GoUpLoading,
    top10GoUpData,
    isTop10GoDownLoading,
    top10GoDownData,
    handleOpenTop10GoUpGoDownTooltip,
    top10GoUpGoDownChartData,
    handlePeriodClick,
    selectedPeriod,
    isTradingVolumeChartLoading,
    tradingValueChartData,
    tradingVolumeChartData,
    isTradingValueChartLoading,
    top10ChartData,
    handleOpenTop10Tooltip,
    isTop10ChartDataLoading,
    chartDataByCode,
    selectedChartPeriod,
    handlesSelectedChartPeriodChange,
    setChartModalShow,
    setSelectedDataChartModal,
    isChartDataByCodeLoading,
    setSelectedChartPeriod,
    isNewsLoading,
    totalPage,
    currentPage,
    setCurrentPage,
    news,
    isNewsSourceLoading,
    newsSource,
    selectedNewsSource,
    handleNewsSourceChange,
    userInfo,
    tradingVolumeExchangeHistoryChartData,
    tradingValueExchangeHistoryChartData,
    marketNews,
    isMarketNewsLoading,
    upTrendingData,
    isUpTrendingDataLoading,
    handleMonthChange,
    sectorTrendingDate,
  };
};

export default useDashboard;
